$(document).ready(function() {
  
  var optionsArray = [
    {
      label: 'Apple', // Group label
      options: [
        { text: 'iPhone Air' },
        { text: 'iPhone 17 Pro Max' },
        { text: 'iPhone 17 Pro' },
        { text: 'iPhone 17' },
        { text: 'iPhone 16e' },
        { text: 'iPhone 16 Pro Max' },
        { text: 'iPhone 16 Pro' },
        { text: 'iPhone 16 Plus' },
        { text: 'iPhone 16' },
        { text: 'iPhone 15 Pro Max' },
        { text: 'iPhone 15 Pro' },
        { text: 'iPhone 15 Plus' },
        { text: 'iPhone 15' },
        { text: 'iPhone 14 Pro Max' },
        { text: 'iPhone 14 Pro' },
        { text: 'iPhone 14 Plus' },
        { text: 'iPhone 14' },
        { text: 'iPhone 13 Pro Max' },
        { text: 'iPhone 13 Pro' },
        { text: 'iPhone 13 Mini' },
        { text: 'iPhone 13' },
        { text: 'iPhone 12 Pro Max' },
        { text: 'iPhone 12 Pro' },
        { text: 'iPhone 12 Mini' },
        { text: 'iPhone 12' },
        { text: 'iPhone 11 Pro Max' },
        { text: 'iPhone 11 Pro' },
        { text: 'iPhone 11' },
        { text: 'iPhone XS Max' },
        { text: 'iPhone XS' },
        { text: 'iPhone XR' },
        { text: 'iPhone X' },
        { text: 'iPhone SE 2022' },
        { text: 'iPhone SE 2020' },
        { text: 'iPhone 8 Plus' },
        { text: 'iPhone 8' },
        { text: 'iPhone 7 Plus' },
        { text: 'iPhone 7' },
        { text: 'iPhone 6S Plus' },
        { text: 'iPhone 6S' },
        { text: 'iPhone 6 Plus' },
        { text: 'iPhone 6' }

      ]
    },
    {
      label: 'Samsung', // Another group
      options: [
        { text: 'Samsung Galaxy S25 Ultra' },
        { text: 'Samsung Galaxy S25 Plus' },
        { text: 'Samsung Galaxy S25' },
        { text: 'Samsung Galaxy S24 Ultra' },
        { text: 'Samsung Galaxy S24 Plus' },
        { text: 'Samsung Galaxy S24 FE' },
        { text: 'Samsung Galaxy S24' },
        { text: 'Samsung Galaxy S23FE' },
        { text: 'Samsung Galaxy S23 Ultra' },
        { text: 'Samsung Galaxy S23 Plus' },
        { text: 'Samsung Galaxy S23' },
        { text: 'Samsung Galaxy S22 Ultra 5G' },
        { text: 'Samsung Galaxy S22 Plus 5G' },
        { text: 'Samsung Galaxy S22 5G' },
        { text: 'Samsung Galaxy S21FE' },
        { text: 'Samsung Galaxy S21 Ultra' },
        { text: 'Samsung Galaxy S21 Plus' },
        { text: 'Samsung Galaxy S21' },
        { text: 'Samsung Galaxy S20 Ultra' },
        { text: 'Samsung Galaxy S20 Plus' },
        { text: 'Samsung Galaxy S20 FE 5G' },
        { text: 'Samsung Galaxy S20 FE' },
        { text: 'Samsung Galaxy S20' },
        { text: 'Samsung Galaxy S10E' },
        { text: 'Samsung Galaxy S10 Plus' },
        { text: 'Samsung Galaxy S10 Lite' },
        { text: 'Samsung Galaxy S10' },
        { text: 'Samsung Galaxy Note 9' },
        { text: 'Samsung Galaxy Note 20 Ultra' },
        { text: 'Samsung Galaxy Note 20 5G' },
        { text: 'Samsung Galaxy Note 20' },
        { text: 'Samsung Galaxy Note 10 Plus' },
        { text: 'Samsung Galaxy Note 10 Lite' },
        { text: 'Samsung Galaxy Note 10' },
        { text: 'Samsung Galaxy M62' },
        { text: 'Samsung Galaxy M55' },
        { text: 'Samsung Galaxy M54 5G' },
        { text: 'Samsung Galaxy M53 5G' },
        { text: 'Samsung Galaxy M52 5G' },
        { text: 'Samsung Galaxy M51' },
        { text: 'Samsung Galaxy M40' },
        { text: 'Samsung Galaxy M35' },
        { text: 'Samsung Galaxy M34 5G' },
        { text: 'Samsung Galaxy M33 5G' },
        { text: 'Samsung Galaxy M32 5G' },
        { text: 'Samsung Galaxy M32' },
        { text: 'Samsung Galaxy M31S' },
        { text: 'Samsung Galaxy M31 Prime' },
        { text: 'Samsung Galaxy M31' },
        { text: 'Samsung Galaxy M30S' },
        { text: 'Samsung Galaxy M30' },
        { text: 'Samsung Galaxy M23 5G' },
        { text: 'Samsung Galaxy M21 2021' },
        { text: 'Samsung Galaxy M21' },
        { text: 'Samsung Galaxy M20' },
        { text: 'Samsung Galaxy M14' },
        { text: 'Samsung Galaxy M12' },
        { text: 'Samsung Galaxy M11' },
        { text: 'Samsung Galaxy M10S' },
        { text: 'Samsung Galaxy M10' },
        { text: 'Samsung Galaxy M02S' },
        { text: 'Samsung Galaxy F62' },
        { text: 'Samsung Galaxy F55' },
        { text: 'Samsung Galaxy F54 5G' },
        { text: 'Samsung Galaxy F42 5G' },
        { text: 'Samsung Galaxy F41' },
        { text: 'Samsung Galaxy F34 5G' },
        { text: 'Samsung Galaxy F23 5G' },
        { text: 'Samsung Galaxy F22' },
        { text: 'Samsung Galaxy F15' },
        { text: 'Samsung Galaxy F14 5G' },
        { text: 'Samsung Galaxy F12' },
        { text: 'Samsung Galaxy F02S' },
        { text: 'Samsung Galaxy A91' },
        { text: 'Samsung Galaxy A81' },
        { text: 'Samsung Galaxy A73 5G' },
        { text: 'Samsung Galaxy A72' },
        { text: 'Samsung Galaxy A71' },
        { text: 'Samsung Galaxy A70S' },
        { text: 'Samsung Galaxy A70' },
        { text: 'Samsung Galaxy A60' },
        { text: 'Samsung Galaxy A55' },
        { text: 'Samsung Galaxy A54 5G' },
        { text: 'Samsung Galaxy A53 5G' },
        { text: 'Samsung Galaxy A52S 5G' },
        { text: 'Samsung Galaxy A52 5G' },
        { text: 'Samsung Galaxy A52' },
        { text: 'Samsung Galaxy A51' },
        { text: 'Samsung Galaxy A50S' },
        { text: 'Samsung Galaxy A50' },
        { text: 'Samsung Galaxy A40S' },
        { text: 'Samsung Galaxy A40' },
        { text: 'Samsung Galaxy A35' },
        { text: 'Samsung Galaxy A34 5G' },
        { text: 'Samsung Galaxy A33 5G' },
        { text: 'Samsung Galaxy A32 5G' },
        { text: 'Samsung Galaxy A32 4G' },
        { text: 'Samsung Galaxy A31' },
        { text: 'Samsung Galaxy A30S' },
        { text: 'Samsung Galaxy A30' },
        { text: 'Samsung Galaxy A25 5G' },
        { text: 'Samsung Galaxy A23 5G' },
        { text: 'Samsung Galaxy A22 5G' },
        { text: 'Samsung Galaxy A22 4G' },
        { text: 'Samsung Galaxy A20' },
        { text: 'Samsung Galaxy A16 5G' },
        { text: 'Samsung Galaxy A15 5G' },
        { text: 'Samsung Galaxy A14 5G' },
        { text: 'Samsung Galaxy A14 4G' },
        { text: 'Samsung Galaxy A12' },
        { text: 'Samsung Galaxy A11' },
        { text: 'Samsung Galaxy A10S' },
        { text: 'Samsung Galaxy A10' },
        { text: 'Samsung Galaxy A06' },
        { text: 'Samsung Galaxy A05S' },
        { text: 'Samsung Galaxy A04' },
        { text: 'Samsung Galaxy A03S' },
        { text: 'Samsung Galaxy A02S' },
        { text: 'Samsung Galaxy S9 Plus' },
        { text: 'Samsung Galaxy S9' },
        { text: 'Samsung Galaxy S8 Plus' },
        { text: 'Samsung Galaxy S8' }
      ]
    },
    {
      label: 'Google Pixel', // Another group
      options: [
        { text: 'Google Pixel 9 Pro XL' },
        { text: 'Google Pixel 9 Pro' },
        { text: 'Google Pixel 9' },
        { text: 'Google Pixel 8A' },
        { text: 'Google Pixel 8 Pro' },
        { text: 'Google Pixel 8' },
        { text: 'Google Pixel 7A' },
        { text: 'Google Pixel 7 Pro' },
        { text: 'Google Pixel 7' },
        { text: 'Google Pixel 6A' },
        { text: 'Google Pixel 6 Pro' },
        { text: 'Google Pixel 6' }
      ]
    },
    {
      label: 'Motorola', // Another group
      options: [
      { text: 'Motorola Edge 50 Ultra' },
      { text: 'Motorola Edge 50 Pro' },
      { text: 'Motorola Edge 50 Fusion' },
      { text: 'Motorola Edge 50' },
      { text: 'Motorola Edge 40 Neo' },
      { text: 'Motorola Edge 40' },
      { text: 'Motorola Edge 30 Ultra' },
      { text: 'Motorola Edge 30 Fusion' },
      { text: 'Motorola Edge 30' },
      { text: 'Motorola Moto G85 5G' },
      { text: 'Motorola Moto G84' },
      { text: 'Motorola Moto G64' },
      { text: 'Motorola Moto G54' },
      { text: 'Motorola Moto G45' }
      ]
    },
    {
      label: 'OnePlus', // Another group
      options: [
        { text: 'Oneplus Ace Racing' },
        { text: 'Oneplus Ace Pro 5G' },
        { text: 'Oneplus Ace 5G' },
        { text: 'Oneplus Ace 2V' },
        { text: 'Oneplus Ace 2 5G' },
        { text: 'Oneplus 13' },
        { text: 'Oneplus 12R' },
        { text: 'Oneplus 12' },
        { text: 'Oneplus 11R 5G' },
        { text: 'Oneplus 11 5G' },
        { text: 'Oneplus 10T 5G' },
        { text: 'Oneplus 10R' },
        { text: 'Oneplus 10 Pro 5G' },
        { text: 'Oneplus 9RT' },
        { text: 'Oneplus 9R' },
        { text: 'Oneplus 9 Pro' },
        { text: 'Oneplus 9' },
        { text: 'Oneplus 8T' },
        { text: 'Oneplus 8 Pro' },
        { text: 'Oneplus 8' },
        { text: 'Oneplus 7T Pro' },
        { text: 'Oneplus 7T' },
        { text: 'Oneplus 7 Pro' },
        { text: 'Oneplus 7' },
        { text: 'Oneplus 6T' },
        { text: 'Oneplus 6' },
        { text: 'Oneplus 5T' },
        { text: 'Oneplus Nord N20 5G' },
        { text: 'Oneplus Nord CE 4 Lite 5G' },
        { text: 'Oneplus Nord CE 5G' },
        { text: 'Oneplus Nord CE 4' },
        { text: 'Oneplus Nord CE 3 Lite' },
        { text: 'Oneplus Nord CE 3 5G' },
        { text: 'Oneplus Nord CE 2 Lite 5G' },
        { text: 'Oneplus Nord CE 2 5G' },
        { text: 'Oneplus Nord 4' },
        { text: 'Oneplus Nord 3 5G' },
        { text: 'Oneplus Nord 2T 5G' },
        { text: 'Oneplus Nord 2' },
        { text: 'Oneplus Nord' }
      ]
    },
    {
      label: 'Nothing Phone', // Another group
      options: [
        { text: 'Nothing Phone 2A' },
        { text: 'Nothing Phone 2' },
        { text: 'Nothing Phone 1' },
        { text: 'Nothing CMF Phone 1' }
      ]
    },
  {
  label: 'Oppo',
  options: [
    { text: 'Oppo Find X8 Pro' },
    { text: 'Oppo Find X8' },
    { text: 'Oppo Find N3 Front' },
    { text: 'Oppo Find N3 Back' },
    { text: 'Oppo Reno 12 Pro 5G' },
    { text: 'Oppo Reno 12 5G' },
    { text: 'Oppo Reno 11 Pro' },
    { text: 'Oppo Reno 11' },
    { text: 'Oppo Reno 10 Pro+ 5G' },
    { text: 'Oppo Reno 10 Pro 5G' },
    { text: 'Oppo Reno 10 5G' },
    { text: 'Oppo Reno 10x Zoom' },
    { text: 'Oppo Reno 8T 5G' },
    { text: 'Oppo Reno 8 Pro 5G' },
    { text: 'Oppo Reno 8 5G' },
    { text: 'Oppo Reno 8 Z' },
    { text: 'Oppo Reno 8 Lite' },
    { text: 'Oppo Reno 8 4G' },
    { text: 'Oppo Reno 7 Pro 5G' },
    { text: 'Oppo Reno 7 5G' },
    { text: 'Oppo Reno 7 Z 5G' },
    { text: 'Oppo Reno 7 Lite' },
    { text: 'Oppo Reno 7' },
    { text: 'Oppo Reno 6 Pro+ 5G' },
    { text: 'Oppo Reno 6 Pro 5G' },
    { text: 'Oppo Reno 6 Pro 5G International' },
    { text: 'Oppo Reno 6 5G' },
    { text: 'Oppo Reno 5 Pro' },
    { text: 'Oppo Reno 5 Lite' },
    { text: 'Oppo Reno 5 F' },
    { text: 'Oppo Reno 4 Pro' },
    { text: 'Oppo Reno 4 Lite' },
    { text: 'Oppo Reno 4F' },
    { text: 'Oppo Reno 3 Pro International' },
    { text: 'Oppo Reno 3' },
    { text: 'Oppo Reno 2Z' },
    { text: 'Oppo Reno 2F' },
    { text: 'Oppo Reno 2' },
    { text: 'Oppo Reno Ace' },
    { text: 'Oppo F27 Pro+' },
    { text: 'Oppo F27 Pro' },
    { text: 'Oppo F25 Pro' },
    { text: 'Oppo F23 5G' },
    { text: 'Oppo F21s Pro 5G' },
    { text: 'Oppo F21s Pro 4G' },
    { text: 'Oppo F21 Pro 5G' },
    { text: 'Oppo F21 Pro 4G' },
    { text: 'Oppo F19 Pro+' },
    { text: 'Oppo F19 Pro' },
    { text: 'Oppo F19' },
    { text: 'Oppo F17 Pro' },
    { text: 'Oppo F17' },
    { text: 'Oppo F15' },
    { text: 'Oppo F11 Pro' },
    { text: 'Oppo K12' },
    { text: 'Oppo K5' },
    { text: 'Oppo K3' },
    { text: 'Oppo A96 International' },
    { text: 'Oppo A94' },
    { text: 'Oppo A93' },
    { text: 'Oppo A91' },
    { text: 'Oppo A9 2020' },
    { text: 'Oppo A79' },
    { text: 'Oppo A78 5G' },
    { text: 'Oppo A74' },
    { text: 'Oppo A73 2020' },
    { text: 'Oppo A59' },
    { text: 'Oppo A58X' },
    { text: 'Oppo A58 International' },
    { text: 'Oppo A5 2020' },
    { text: 'Oppo A3 Pro' },
    { text: 'Oppo A11X' },
    { text: 'Oppo A11' },
    { text: 'Oppo A1 Pro' }
  ]
},
 {
  "label": "Realme",
  "options": [
    { "text": "Realme GT Neo 6" },
    { "text": "Realme GT Neo 6 SE" },
    { "text": "Realme GT 7 Pro" },
    { "text": "Realme GT 6T" },
    { "text": "Realme GT 6" },
    { "text": "Realme GT Neo 3T" },
    { "text": "Realme GT Neo 3" },
    { "text": "Realme GT Neo 2T" },
    { "text": "Realme GT Neo 2" },
    { "text": "Realme GT Neo Flash" },
    { "text": "Realme GT 2 Pro" },
    { "text": "Realme GT 2" },
    { "text": "Realme GT 5G" },
    { "text": "Realme Narzo 70 Turbo" },
    { "text": "Realme Narzo 70 Pro" },
    { "text": "Realme Narzo 70x" },
    { "text": "Realme Narzo 70" },
    { "text": "Realme Narzo 60x 5G" },
    { "text": "Realme Narzo 60 Pro" },
    { "text": "Realme Narzo 60" },
    { "text": "Realme Narzo 50 Pro" },
    { "text": "Realme Narzo 30 5G" },
    { "text": "Realme Narzo 20 Pro" },
    { "text": "Realme Narzo 10" },
    { "text": "Realme C75" },
    { "text": "Realme C65 5G" },
    { "text": "Realme 14x" },
    { "text": "Realme 14 Pro Plus" },
    { "text": "Realme 14 Pro" },
    { "text": "Realme 13 Pro Plus" },
    { "text": "Realme 13 Pro" },
    { "text": "Realme 13" },
    { "text": "Realme 12x" },
    { "text": "Realme 12 Pro Plus" },
    { "text": "Realme 12 Pro" },
    { "text": "Realme 12 Plus" },
    { "text": "Realme 12" },
    { "text": "Realme 11x 5G" },
    { "text": "Realme 11 Pro+" },
    { "text": "Realme 11 Pro" },
    { "text": "Realme 11 International" },
    { "text": "Realme 11 5G" },
    { "text": "Realme 10 Pro Plus 5G" },
    { "text": "Realme 10 Pro 5G" },
    { "text": "Realme 10 5G" },
    { "text": "Realme 9 Pro Plus 5G" },
    { "text": "Realme 9 Pro 5G" },
    { "text": "Realme 9 5G Speed Edition" },
    { "text": "Realme 9 5G" },
    { "text": "Realme 9 4G" },
    { "text": "Realme 9i 4G" },
    { "text": "Realme 8s 5G" },
    { "text": "Realme 8 Pro" },
    { "text": "Realme 8 5G" },
    { "text": "Realme 8" },
    { "text": "Realme 7 Pro" },
    { "text": "Realme 7" },
    { "text": "Realme 6s" },
    { "text": "Realme 6i" },
    { "text": "Realme 6 Pro" },
    { "text": "Realme 6" },
    { "text": "Realme 5s" },
    { "text": "Realme 5 Pro" },
    { "text": "Realme 5" },
    { "text": "Realme 3 Pro" },
    { "text": "Realme XT" },
    { "text": "Realme X7 Pro" },
    { "text": "Realme X7 Max 5G" },
    { "text": "Realme X7 International" },
    { "text": "Realme X50 Pro" },
    { "text": "Realme X2 Pro" },
    { "text": "Realme X2" },
    { "text": "Realme X Lite" },
    { "text": "Realme X" },
    { "text": "Realme V60 Pro" },
    { "text": "Realme V25" },
    { "text": "Realme V13 5G" },
    { "text": "Realme Q5 Pro" },
    { "text": "Realme Q5" },
    { "text": "Realme Q3i 5G" },
    { "text": "Realme Q3 Pro 5G" },
    { "text": "Realme Q3 5G" },
    { "text": "Realme Q2 Pro International" },
    { "text": "Realme P2 Pro" },
    { "text": "Realme P1 Pro" },
    { "text": "Realme P1" }
  ]
},

    {
      label: 'Xiaomi / Redmi / Poco', // Another group
      options: [
      { text: 'Xiaomi Redmi Note 9S' },
      { text: 'Xiaomi Redmi Note 9 Pro Max' },
      { text: 'Xiaomi Redmi Note 9 Pro 5G' },
      { text: 'Xiaomi Redmi Note 9 Pro' },
      { text: 'Xiaomi Redmi Note 9' },
      { text: 'Xiaomi Redmi Note 8 Pro' },
      { text: 'Xiaomi Redmi Note 8 2021' },
      { text: 'Xiaomi Redmi Note 8' },
      { text: 'Xiaomi Redmi Note 7S' },
      { text: 'Xiaomi Redmi Note 7 Pro' },
      { text: 'Xiaomi Redmi Note 7' },
      { text: 'Xiaomi Redmi Note 14 Pro Plus' },
      { text: 'Xiaomi Redmi Note 14 Pro' },
      { text: 'Xiaomi Redmi Note 13 Pro Plus' },
      { text: 'Xiaomi Redmi Note 13 Pro' },
      { text: 'Xiaomi Redmi Note 13' },
      { text: 'Xiaomi Redmi Note 12 Pro Plus' },
      { text: 'Xiaomi Redmi Note 12 Pro' },
      { text: 'Xiaomi Redmi Note 12 5G' },
      { text: 'Xiaomi Redmi Note 12 4G' },
      { text: 'Xiaomi Redmi Note 11T Pro Plus' },
      { text: 'Xiaomi Redmi Note 11T Pro' },
      { text: 'Xiaomi Redmi Note 11T 5G' },
      { text: 'Xiaomi Redmi Note 11Se 5G International' },
      { text: 'Xiaomi Redmi Note 11S 5G' },
      { text: 'Xiaomi Redmi Note 11S' },
      { text: 'Xiaomi Redmi Note 11E Pro' },
      { text: 'Xiaomi Redmi Note 11 Se' },
      { text: 'Xiaomi Redmi Note 11 Pro+ 5G' },
      { text: 'Xiaomi Redmi Note 11 Pro Plus 5G International' },
      { text: 'Xiaomi Redmi Note 11 Pro 5G International' },
      { text: 'Xiaomi Redmi Note 11 Pro' },
      { text: 'Xiaomi Redmi Note 11 International' },
      { text: 'Xiaomi Redmi Note 11' },
      { text: 'Xiaomi Redmi Note 10T 5G' },
      { text: 'Xiaomi Redmi Note 10S' },
      { text: 'Xiaomi Redmi Note 10 Pro Max' },
      { text: 'Xiaomi Redmi Note 10 Pro' },
      { text: 'Xiaomi Redmi Note 10 Lite' },
      { text: 'Xiaomi Redmi Note 10 5G' },
      { text: 'Xiaomi Redmi Note 10' },
      { text: 'Xiaomi Redmi K50I' },
      { text: 'Xiaomi Redmi K40 Gaming' },
      { text: 'Xiaomi Redmi K40' },
      { text: 'Xiaomi Redmi K30I 5G' },
      { text: 'Xiaomi Redmi K30' },
      { text: 'Xiaomi Redmi K20 Pro' },
      { text: 'Xiaomi Redmi K20' },
      { text: 'Xiaomi Redmi 9T' },
      { text: 'Xiaomi Redmi 9 Power' },
      { text: 'Xiaomi Redmi 7A' },
      { text: 'Xiaomi Redmi 13C 5G' },
      { text: 'Xiaomi Redmi 13 5G' },
      { text: 'Xiaomi Redmi 12 5G' },
      { text: 'Xiaomi Redmi 12 4G' },
      { text: 'Xiaomi Redmi 10X 4G' },
      { text: 'Xiaomi Poco X6 Pro' },
      { text: 'Xiaomi Poco X6' },
      { text: 'Xiaomi Poco X5 Pro 5G' },
      { text: 'Xiaomi Poco X5 5G' },
      { text: 'Xiaomi Poco X5' },
      { text: 'Xiaomi Poco X4 Pro 5G' },
      { text: 'Xiaomi Poco X4 Gt' },
      { text: 'Xiaomi Poco X3 Pro' },
      { text: 'Xiaomi Poco X3 Nfc' },
      { text: 'Xiaomi Poco X3' },
      { text: 'Xiaomi Poco X2' },
      { text: 'Xiaomi Poco M6 Pro 5G' },
      { text: 'Xiaomi Poco M5S' },
      { text: 'Xiaomi Poco M4 Pro 5G' },
      { text: 'Xiaomi Poco M3 Pro 5G' },
      { text: 'Xiaomi Poco M2 Pro' },
      { text: 'Xiaomi Poco F6' },
      { text: 'Xiaomi Poco F5 5G' },
      { text: 'Xiaomi Poco F4 5G' },
      { text: 'Xiaomi Poco F3 Gt' },
      { text: 'Xiaomi Poco F3' },
      { text: 'Xiaomi Poco F1' },
      { text: 'Xiaomi Mi Note 10 International' },
      { text: 'Xiaomi Mi A3' },
      { text: 'Xiaomi Mi 9T Pro' },
      { text: 'Xiaomi Mi 9T' },
      { text: 'Xiaomi Mi 11X Pro' },
      { text: 'Xiaomi Mi 11X' },
      { text: 'Xiaomi Mi 11 Ultra' },
      { text: 'Xiaomi Mi 10T Pro' },
      { text: 'Xiaomi Mi 10T Lite 5G' },
      { text: 'Xiaomi Mi 10T' },
      { text: 'Xiaomi Mi 10I' },
      { text: 'Xiaomi 14 Ultra' },
      { text: 'Xiaomi 14' },
      { text: 'Xiaomi 13 Pro' },
      { text: 'Xiaomi 12X' },
      { text: 'Xiaomi 12S Pro' },
      { text: 'Xiaomi 12 Pro 5G' },
      { text: 'Xiaomi 12 Lite 5G' },
      { text: 'Xiaomi 11T Pro 5G' },
      { text: 'Xiaomi 11T 5G' },
      { text: 'Xiaomi 11I Hypercharge 5G' },
      { text: 'Xiaomi 11I 5G' },
      { text: 'Xiaomi 11 Lite Ne 5G' },
      { text: 'Xiaomi 11 Lite' }

      ]
    },
    {
      label: 'Vivo / IQOO', // Another group
      options: [
        { text: 'Vivo IQOO 10' },
        { text: 'Vivo IQOO 11' },
        { text: 'Vivo IQOO 12' },
        { text: 'Vivo IQOO 3' },
        { text: 'Vivo IQOO 7' },
        { text: 'Vivo IQOO 7 Legend 5G' },
        { text: 'Vivo IQOO 8 5G' },
        { text: 'Vivo IQOO 9 5G' },
        { text: 'Vivo IQOO 9 5G International' },
        { text: 'Vivo IQOO 9 Pro 5G' },
        { text: 'Vivo IQOO 9 SE 5G' },
        { text: 'Vivo IQOO 9T 5G' },
        { text: 'Vivo IQOO Neo 5' },
        { text: 'Vivo IQOO Neo 5 S' },
        { text: 'Vivo IQOO Neo 6 5G' },
        { text: 'Vivo IQOO Neo 7' },
        { text: 'Vivo IQOO Neo 7 Pro' },
        { text: 'Vivo IQOO Neo 6 SE' },
        { text: 'Vivo IQOO Neo 7 Racing' },
        { text: 'Vivo IQOO Neo 7 SE' },
        { text: 'Vivo IQOO Neo 9' },
        { text: 'Vivo IQOO Neo9 Pro' },
        { text: 'Vivo IQOO U5E' },
        { text: 'Vivo IQOO Z3' },
        { text: 'Vivo IQOO Z5' },
        { text: 'Vivo IQOO Z6' },
        { text: 'Vivo IQOO Z6 International' },
        { text: 'Vivo IQOO Z6 Lite' },
        { text: 'Vivo IQOO Z6 Pro 5G' },
        { text: 'Vivo IQOO Z6X' },
        { text: 'Vivo IQOO Z7' },
        { text: 'Vivo IQOO Z7 International' },
        { text: 'Vivo IQOO Z7 Pro 5G' },
        { text: 'Vivo IQOO Z7S' },
        { text: 'Vivo IQOO Z9' },
        { text: 'Vivo IQOO Z9 Lite' },
        { text: 'Vivo IQOOz9X' },
        { text: 'Vivo S1' },
        { text: 'Vivo S1 Pro' },
        { text: 'Vivo S1 Pro International' },
        { text: 'Vivo S10E' },
        { text: 'Vivo S12' },
        { text: 'Vivo S12 Pro' },
        { text: 'Vivo S15 Pro' },
        { text: 'Vivo S15E' },
        { text: 'Vivo S16' },
        { text: 'Vivo S16 Pro' },
        { text: 'Vivo S16E' },
        { text: 'Vivo S18' },
        { text: 'Vivo S18 Pro' },
        { text: 'Vivo S7' },
        { text: 'Vivo T1 5G' },
        { text: 'Vivo T1 Pro 5G' },
        { text: 'Vivo T2 5G' },
        { text: 'Vivo T2 Pro 5G' },
        { text: 'Vivo T2X 5G International' },
        { text: 'Vivo T3 Ultra' },
        { text: 'Vivo T3 5G' },
        { text: 'Vivo T3X' },
        { text: 'Vivo V15 Pro' },
        { text: 'Vivo V17' },
        { text: 'Vivo V17 Pro' },
        { text: 'Vivo V19' },
        { text: 'Vivo V20' },
        { text: 'Vivo V20 Pro' },
        { text: 'Vivo V20 SE' },
        { text: 'Vivo V21' },
        { text: 'Vivo V21 5G' },
        { text: 'Vivo V21E' },
        { text: 'Vivo V21S' },
        { text: 'Vivo V23 5G' },
        { text: 'Vivo V23 Pro 5G' },
        { text: 'Vivo V23E 5G' },
        { text: 'Vivo V25 5G' },
        { text: 'Vivo V25 Pro 5G' },
        { text: 'Vivo V25E' },
        { text: 'Vivo V27' },
        { text: 'Vivo V27 Pro' },
        { text: 'Vivo V27E' },
        { text: 'Vivo V29' },
        { text: 'Vivo V29 Pro' },
        { text: 'Vivo V29E' },
        { text: 'Vivo V30' },
        { text: 'Vivo V30 Pro' },
        { text: 'Vivo V30E' },
        { text: 'Vivo V40' },
        { text: 'Vivo V40E' },
        { text: 'Vivo V40 Pro' },
        { text: 'Vivo X100' },
        { text: 'Vivo X100 Pro' },
        { text: 'Vivo X60' },
        { text: 'Vivo X60 Pro' },
        { text: 'Vivo X60T' },
        { text: 'Vivo X70' },
        { text: 'Vivo X70 Pro' },
        { text: 'Vivo X80 5G' },
        { text: 'Vivo X80 Lite' },
        { text: 'Vivo X80 Pro 5G' },
        { text: 'Vivo X90' },
        { text: 'Vivo X90 Pro' },
        { text: 'Vivo Y03' },
        { text: 'Vivo Y100' },
        { text: 'Vivo Y100 International' },
        { text: 'Vivo Y100A' },
        { text: 'Vivo Y16' },
        { text: 'Vivo Y18E' },
        { text: 'Vivo Y300 Plus' },
        { text: 'Vivo Y200' },
        { text: 'Vivo Y200 Pro' },
        { text: 'Vivo Y200E' },
        { text: 'Vivo Y200T' },
        { text: 'Vivo Y22' },
        { text: 'Vivo Y22S' },
        { text: 'Vivo Y27' },
        { text: 'Vivo Y28S' },
        { text: 'Vivo Y30 5G' },
        { text: 'Vivo Y33E' },
        { text: 'Vivo Y33S 5G' },
        { text: 'Vivo Y35' },
        { text: 'Vivo Y35+ 5G' },
        { text: 'Vivo Y36' },
        { text: 'Vivo Y38' },
        { text: 'Vivo Y52 5G' },
        { text: 'Vivo Y52T' },
        { text: 'Vivo Y55 5G' },
        { text: 'Vivo Y56 5G' },
        { text: 'Vivo Y70' },
        { text: 'Vivo Y72 5G International' },
        { text: 'Vivo Y73' },
        { text: 'Vivo Y73T' },
        { text: 'Vivo Y75 5G' },
        { text: 'Vivo Y75S' },
        { text: 'Vivo Z1 Pro' },
        { text: 'Vivo Z1X' },
        { text: 'Vivo Z5X' }
  ]
    }
    ];

  // Initialize Select2
  $('.brandSelect').select2({
    placeholder: "Please Choose Your Phone Model or Search", // Set the placeholder
  });

  var placeholderOption = new Option("", "", false, false);
  $('.brandSelect').append(placeholderOption);

  // Iterate through the optionsArray and create optgroup and options
  optionsArray.forEach(function(group) {
    // Create the optgroup for each label
    var optgroup = $('<optgroup>').attr('label', group.label);
    
    // Loop through each option within the group and create the option elements
    group.options.forEach(function(option) {
      var newOption = new Option(option.text, option.text, false, false);
      optgroup.append(newOption);
    });

    // Append the optgroup to the select element
    $('.brandSelect').append(optgroup);
  });

  // Trigger the change event to refresh Select2
  $('.brandSelect').trigger('change');
   const error = document.querySelector('.error_select_device');
   $('.brandSelect').on('change', function() {
    var selectedValue = $(this).val(); // Get the selected value

    if (selectedValue && selectedValue !== "") {
      console.log(error);
      error.hidden = true;
    } 
  });
});
